<!--
 * @Author: zl
 * @Date: 2021-11-08 14:35:40
 * @LastEditTime: 2021-11-17 14:44:00
 * @LastEditors: zl
 * @Description: 单位详情
-->
<template>
	<el-dialog title="查看单位详情"
			   :visible.sync="unitShow"
			   @closed="closeState"
			   width="1200px"
			   top="10vh"
			   center>
		<el-form ref="objectForm"
				 :model="objectForm"
				 label-width="150px"
				 v-if="unitShow">
			<el-row>
				<el-collapse v-model="activeName">
					<el-collapse-item title="#1 企业基本信息"
									  name="1">
						<el-col :span="12">
							<el-form-item label="企业/组织名称："
										  prop="sname">
								{{ objectForm.sname }}
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="企业/组织简称："
										  prop="shortName">
								{{ objectForm.shortName }}
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="主体类型："
										  prop="limitId">
								{{ objectForm.limitName }}
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="社会统一信用代码："
										  prop="creditCode">
								{{ objectForm.creditCode }}
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="单位性质："
										  prop="companyType">
								{{ objectForm.companyTypeName }}
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="法人代表："
										  prop="legal">
								{{ objectForm.legal }}
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="法人代表手机号："
										  prop="legalPhone">
								{{ objectForm.legalPhone }}
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="法人代表身份证号："
										  prop="legalIdCard">
								{{ objectForm.legalIdCard }}
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="办公地址："
										  prop="address">
								{{ objectForm.address }}
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="企业联系人："
										  prop="linkman">
								{{ objectForm.linkman }}
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="联系人手机号："
										  prop="linkPhone">
								{{ objectForm.linkPhone }}
							</el-form-item>
						</el-col>
						<el-col :span="12">
							{{ objectForm.industryArray }}
							</el-form-item>
						</el-col>
						<el-col :span="24">
							<el-form-item label="备注："
										  prop="remark">
								{{ objectForm.remark }}
							</el-form-item>
						</el-col>
					</el-collapse-item>
					<el-collapse-item title="#2 企业账户信息"
									  name="2">
						<el-col :span="24">
							<vxe-table align="center"
									   resizable
									   border
									   :data="accountObj.table"
									   highlight-current-row
									   show-overflow="tooltip"
									   show-header-overflow="tooltip">
								<vxe-table-column title="序号"
												  type="seq"
												  width="70"></vxe-table-column>
								<vxe-table-column title="收款户名"
												  field="sname"
												  header-align="center"
												  align="left"></vxe-table-column>
								<vxe-table-column title="收款账号"
												  field="account"></vxe-table-column>
								<vxe-table-column title="开户银行"
												  field="openBankName"></vxe-table-column>
								<vxe-table-column title="支行"
												  field="subBank"
												  header-align="center"
												  align="left"></vxe-table-column>
								<vxe-table-column title="设置默认收款账户"
												  field="isDefault">
									<template #default="{ row }">
										<vxe-switch v-model="row.isDefault"
													open-label="是"
													:open-value="1"
													close-label="否"
													:close-value="0"
													disabled></vxe-switch>
									</template>
								</vxe-table-column>
							</vxe-table>
						</el-col>
					</el-collapse-item>
				</el-collapse>
			</el-row>
		</el-form>
	</el-dialog>
</template>
<script>
import { getTenantAcounts, getObjectById } from 'api/system/sysTenant'
export default {
	components: {},
	props: {
		selectCompany: {
			type: Object,
			default: () => {
				return {}
			},
		},
	},
	data() {
		return {
			activeName: ['1', '2'],
			accountObj: {
				table: [],
			},
			unitShow: false,
			objectForm: {},
		}
	},
	created() {
		// 获取企业账户列表
		this.getTenantAcounts()
		// 获取当前公司信息
		this.getObjectById()
	},
	methods: {
		// 获取企业账户列表
		getTenantAcounts() {
			getTenantAcounts({
				tenantId: this.selectCompany.tenantId,
			}).then((res) => {
				this.accountObj.table = res.data
			})
		},

		// 获取当前公司信息
		getObjectById() {
			getObjectById({
				id: this.selectCompany.tenantId,
			}).then((res) => {
				this.objectForm = res.data
			})
		},

		closeState() {
			this.$emit('sendState', false)
		},
	},
	watch: {
		selectCompany: {
			handler(val, oldval) {
				if (val) {
					this.getTenantAcounts()
					this.getObjectById()
				}
			},
			deep: true,
		},
	},
}
</script>
<style lang='less' scoped>
.el-collapse {
	border-bottom: none;
	.el-collapse-item {
		margin-bottom: 15px;
	}
	/deep/ .el-collapse-item__header {
		padding-left: 15px;
		font-size: 16px;
		background-color: #eff6fe;
	}
	/deep/ .el-collapse-item__wrap {
		border-bottom: none;
	}
	/deep/ .el-collapse-item__content {
		padding: 15px;
	}
}
.el-form-item {
	margin-bottom: 0 !important;
}
</style>
